import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { ChapterTick } from "./marks";

/** As Told: where a yarn splits off back in time, the words for how far back. */
export function timeJumpTicks(layout: BookTimelineLayout): ChapterTick[] {
  return layout.rail.branches.flatMap((branch) => (
    branch.timeLabel === undefined ? [] : [{
      chapterId: `time-jump-${branch.id}`,
      label: branch.timeLabel,
      startMs: branch.startMs,
      locationLabel: branch.label,
    }]
  ));
}

/** Universe-view ticks from compiled time marks. */
export function timeMarkTicks(layout: BookTimelineLayout): ChapterTick[] {
  return (layout.timeMarks ?? []).map((mark) => ({
    chapterId: `time-${mark.startMs}`,
    label: mark.label,
    startMs: mark.startMs,
    locationLabel: beatLocation(layout, mark.startMs),
  }));
}

function beatLocation(layout: BookTimelineLayout, startMs: number): string {
  const beat = layout.beats.find(
    (item) => item.startMs <= startMs && startMs < item.endMs,
  );
  return beat?.locationLabel ?? layout.beats[0]?.locationLabel ?? "";
}
